module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAARUlEQVQ4y2P4jwQ+MAww7wADDNgPPI//D5Dx/8+g4THw//8/KHggBsJlA82DRNsg4AFpIMH8f5DwQAyGwcIbJHl68JR1AGpIpA9zTiKFAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI2OjQzKzA5OjAweQ3b9QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyNiswOTowMMvnDN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00295_100x100.png
// module id = TWbN
// module chunks = 0